import React, { useState, useEffect } from "react";
import { Input } from "antd";
import { useUserStore } from "../../../store/userStore.js";


import EditProfileBoxLabel from "../../../components/label/editprofileboxlabel";
import PrimaryButton from "../../../components/button/primarybutton";
import ApprovedButton from "../../../components/button/approvedbutton";
import PendingButton from "../../../components/button/pendingbutton";
import RejectedButton from "../../../components/button/rejectedbutton";
import Loader from "../../../components/loader/loader";

import Spacer from "../../../components/spacer/spacer";
import images from "../../../assets";

import TabHeading from "./tabheading";
import "./styles.css";
const { TextArea } = Input;

const ProfileDescription = () => {
  const { user, isUserLoading, getUser, updateUser } = useUserStore();

  const [profileDescription, setProfileDescription] = useState("");

  useEffect(() => {
    setProfileDescription(user?.profileDescription ?? "");
  }, [isUserLoading]);

  const getprofileData = () => {
    const payload = { username: user?.username };
    getUser(payload);
  };

  const handleSubmit = () => {
    const payload = {
      username: user?.username,
      data: {
        profileDescription: profileDescription.trim(),
        profileDescriptionStatus: "approved",
      },
    };
    updateUser(payload, () => {
      getprofileData();
    });
  };

  return (
    <>
      <TabHeading
        image={images.editProfileDescription}
        title="Profile Description"
        subtitle="Complete to easily find your ideal partner!"
      />
      <div className="edit-profile-content">
        {isUserLoading ? (
          <Loader />
        ) : (
          <>
            {/* Write a Short Description About Yourself */}
            <div className="edit-profile-label-container">
              <EditProfileBoxLabel label="Write a Short Description About Yourself" />
              {user?.profileDescriptionStatus === "approved" ? (
                <ApprovedButton />
              ) : user?.profileDescriptionStatus === "pending" ? (
                <PendingButton />
              ) : user?.profileDescriptionStatus === "rejected" ? (
                <RejectedButton />
              ) : null}
            </div>
            <Spacer height="8px" />
            <div className="edit-profile-input">
              <TextArea
                style={{
                  width: "100%",
                  outline: "none",
                  background: "transparent",
                  border: "none",
                  boxShadow: "none",
                }}
                // showCount
                maxLength={1000}
                rows="10"
                onChange={(e) => setProfileDescription(e.target.value)}
                placeholder="Write a Short Description About Yourself"
                value={profileDescription || undefined}
              />
            </div>
            <Spacer height="8px" />
          </>
        )}
        <Spacer height="32px" />
        <PrimaryButton
          text="Save & Continue"
          onClick={handleSubmit}
          disabled={isUserLoading}
        />
      </div>
    </>
  );
};

export default ProfileDescription;








